import { LoadableElement } from '@99designs/common/components/LoadableElement';
import { BriefEntry, BriefEntryVariables } from '__generated__/BriefEntry';
import { BriefSchema, DesignerSource } from '__generated__/types';
import { onReject } from 'common/utils/Bugsnag';
import { trackResumedBriefEvent } from 'projects/events';
import AppendStructuredBriefDesigners from 'projects/mutations/AppendStructuredBriefDesigners';
import CopyBrief from 'projects/mutations/CopyBrief';
import CreateBrief, { CreateBriefOnMount } from 'projects/mutations/CreateBrief';
import BriefEntryPage from 'projects/routes/BriefEntryPage';
import qs from 'qs';
import React from 'react';
import { Query } from 'react-apollo';
import { RouteComponentProps } from 'react-router-dom';
import { routes } from '.';
import query from './BriefEntry.graphql';
import { history } from './BrowserRouter';

interface QueryParams {
    designerId?: number;
    category?: string;
}

export const parseQueryString = (query: string): QueryParams => {
    // react router is dumb and includes the `?` in the query string,
    // which qs adds to the first key name. YOU HAD ONE JOB!
    if (query[0] == '?') {
        query = query.slice(1);
    }
    const { designerId, category } = qs.parse(query);
    return {
        designerId: designerId ? parseInt(designerId) : undefined,
        category,
    };
};

class BriefEntryComponent extends React.Component<
    RouteComponentProps,
    { isRunningMutation: boolean }
> {
    state = {
        isRunningMutation: false,
    };
    render() {
        const { designerId, category } = parseQueryString(this.props.location.search);
        return (
            <Query<BriefEntry, BriefEntryVariables>
                query={query}
                variables={{
                    id: designerId,
                    schemas: [
                        BriefSchema.PREZI,
                        BriefSchema.PROJECT,
                        BriefSchema.SQUARESPACE,
                        BriefSchema.SQUARESPACE_API,
                    ],
                }}
            >
                {({ loading, error, data }) => {
                    if (loading) {
                        return <LoadableElement variations={['fade-in']} isLoading={true} />;
                    }
                    if (error) {
                        return <CreateBriefOnMount fields={{ project: { category } }} />;
                    }
                    if (data) {
                        const variables = {
                            designerIds: data.designer ? [data.designer.id] : undefined,
                            fields: { project: { category } },
                        };

                        if (!data.viewer.user || (!data.drafts.length && !data.launched.length)) {
                            return <CreateBriefOnMount {...variables} />;
                        }

                        return (
                            <CreateBrief>
                                {createBrief => (
                                    <AppendStructuredBriefDesigners>
                                        {appendDesigners => (
                                            <CopyBrief>
                                                {copyBrief => {
                                                    if (this.state.isRunningMutation) {
                                                        return (
                                                            <LoadableElement
                                                                variations={['fade-in']}
                                                                isLoading={true}
                                                            />
                                                        );
                                                    }

                                                    return (
                                                        <BriefEntryPage
                                                            designer={data.designer}
                                                            recentDrafts={data.drafts}
                                                            recentLaunchedBriefs={data.launched}
                                                            createBriefAction={() => {
                                                                this.setState({
                                                                    isRunningMutation: true,
                                                                });
                                                                createBrief(variables);
                                                            }}
                                                            copyBriefAction={async brief => {
                                                                this.setState({
                                                                    isRunningMutation: true,
                                                                });

                                                                const res = await copyBrief({
                                                                    id: brief.id,
                                                                    designerIds:
                                                                        variables.designerIds,
                                                                });

                                                                if (res) {
                                                                    history.push(
                                                                        routes.briefStep(
                                                                            res.data!.brief,
                                                                            1
                                                                        )
                                                                    );
                                                                }
                                                            }}
                                                            resumeBriefAction={brief => {
                                                                trackResumedBriefEvent({
                                                                    id: brief.id,
                                                                });
                                                                if (designerId) {
                                                                    this.setState({
                                                                        isRunningMutation: true,
                                                                    });
                                                                    appendDesigners({
                                                                        id: brief.id,
                                                                        designerIds: [designerId],
                                                                        source:
                                                                            DesignerSource.DIRECT,
                                                                    }).then(
                                                                        () =>
                                                                            history.push(
                                                                                routes.briefStep(
                                                                                    brief,
                                                                                    1
                                                                                )
                                                                            ),
                                                                        onReject(
                                                                            'BriefEntry Component'
                                                                        )
                                                                    );
                                                                } else {
                                                                    history.push(
                                                                        routes.briefStep(brief, 1)
                                                                    );
                                                                }
                                                            }}
                                                            user={data.viewer.user!}
                                                        />
                                                    );
                                                }}
                                            </CopyBrief>
                                        )}
                                    </AppendStructuredBriefDesigners>
                                )}
                            </CreateBrief>
                        );
                    }
                    return null;
                }}
            </Query>
        );
    }
}

export default BriefEntryComponent;
